import React, { Component } from 'react'
import { Link } from 'react-router'
import { makeDefaultFailedContainer } from 'components/container'
import Toggle from 'components/Toggle'
import IntegrationConnector from '../components/IntegrationConnector'
import { APP_URL, HUBSPOT_CLIENT_ID } from 'constants/ResourcesConstants'
import { HUBSPOT_HELPDOC_URL } from 'constants/HelpDocConstants'
import ACCESS from 'utils/Access'
import app from 'containers/app'

const AUTH_LINK = "https://app.hubspot.com/oauth/authorize"
const INSTALL_PAGE_LINK = `${ APP_URL }/settings/setup/install`
const HUBSPOT_INSTALL_DOC = 'https://knowledge.hubspot.com/articles/kcs_article/cos-general/add-a-javascript-file-to-hubspot'

const HUBSPOT_PAYLOAD = {
  client_id: HUBSPOT_CLIENT_ID,
  redirect_uri: `${ APP_URL }/accept-integration/hubspot`
}

const RAW_PARAM_PAYLOAD = '&scope=contacts%20timeline%20forms%20content'

export class HubSpot extends Component {

  componentWillReceiveProps({ hubspotTimelineState, hubspotCookieState, orgProps }) {
    const currentTimelineState = this.props.hubspotTimelineState
    const currentHubspotCookieState = this.props.hubspotCookieState
    const orgActivated = this.props.orgProps.orgActivated


    if (currentTimelineState !== hubspotTimelineState || currentHubspotCookieState !== hubspotCookieState) {
      this.app.actions.NotificationActions.pushNotification({ content: 'Your settings were successfully updated.' })
    }

    if (orgActivated !== orgProps.orgActivated && orgProps.orgActivated) {
      this.app.actions.NotificationActions.pushNotification({
        content: 'Drift is successfully set up and ready to go!',
      })
      this.app.queries.IntegrationsQueries.fetchIntegrationStates()
    }
  }

  handleTimelineStateChange = ({ target }) => {
    this.app.queries.IntegrationsQueries.updateHubspotTimelineState(target.checked)
    this.app.queries.IntegrationsQueries.fetchIntegrationStates()
  }

  handleCookieTrackingStateChange = ({ target }) => {
    this.app.queries.IntegrationsQueries.updateHubspotCookieState(target.checked).then(() => {
      this.app.queries.IntegrationsQueries.fetchIntegrationStates()
    })
  }

  onIntegrationConnected = () => {
    app.queries.IntegrationsQueries.fetchIntegrationStates()
  }

  renderEmbedToggle = () => {
    const { hubspotTimelineState, hubspotCookieState } = this.props
    return (
      <div>
        <div className="flex" style={{ paddingBottom: '1rem' }}>
          <Toggle defaultChecked={ hubspotTimelineState }
            id="hubspot-timeline-state"
            onChange={ this.handleTimelineStateChange.bind(this) }
          />
          <div style={{ paddingLeft: '1rem' }}>Sync activities from Drift to my HubSpot contact database</div>
        </div>
        <div className="flex" style={{ paddingBottom: '1rem' }}>
          <Toggle defaultChecked={ hubspotCookieState }
            id="hubspot-cookie-state"
            onChange={ this.handleCookieTrackingStateChange.bind(this) }
          />
          <div style={{ paddingLeft: '1rem' }}>Identify visitors using the HubSpot cookie</div>
        </div>
      </div>
    )
  }

  render() {
    const { isConnected } = this.props
    return (
      <div>
        <p>Using HubSpot? Great! Toggling the options below will allow you to send conversation events into HubSpot as well as automatically identify visitors using the HubSpot cookie.</p>
        <p>To install Drift on your Hubspot hosted site, copy the Drift Javascript snippet from our <a href={INSTALL_PAGE_LINK} target="_blank">install page</a>, then follow Hubspot's directions <a href={HUBSPOT_INSTALL_DOC} target="_blank">here</a>.</p>
        <p>Want more information? <a href={HUBSPOT_HELPDOC_URL} target="_blank">Learn More.</a></p>

        {!isConnected &&
          <div className="connect-container">
            <IntegrationConnector
              onIntegrationConnected={this.onIntegrationConnected}
              integrationId="hubspot"
              isOauth={true}
              oauthLink={AUTH_LINK}
              title="Connect Account"
              connectorType="button"
              buttonType="primary"
              className="hubspot-integration-connector"
              oauthQueryParams={HUBSPOT_PAYLOAD}
              oauthRawParams={RAW_PARAM_PAYLOAD} />
          </div>
        }

        {isConnected &&
          <Link to="/settings/hubspot/config" className="integration-config-link">
            <h2 className="integration-section-title">
              Synced Hubspot Data
            </h2>
            <p>Choose which data is sent between Hubspot and Drift.</p>
          </Link>
        }
        {(isConnected && ACCESS.hasGates('HUBSPOT_MAPPING')) &&
          <Link to="/settings/hubspot/mapping/attributes" className="integration-config-link">
            <h2 className="integration-section-title">
              Mapped Hubspot Attributes
            </h2>
            <p>Map which fields you want to sync between Drift and Hubspot.</p>
          </Link>
        }
        {(isConnected && ACCESS.hasGates('HUBSPOT_USER_MAPPING')) &&
          <Link to="/settings/hubspot/mapping/users" className="integration-config-link">
            <h2 className="integration-section-title">
              Mapped Hubspot Users
            </h2>
            <p>Map your Drift Teammates to your Hubspot Teammates.</p>
          </Link>
        }

        {isConnected &&
          <Link to="/settings/hubspot/event-log" className="integration-config-link">
            View Hubspot Event Log
          </Link>
        }

      </div>
    )
  }
}

const HubSpotContainer = makeDefaultFailedContainer(HubSpot, {
  listenTo: ['stores.IntegrationsStore'],
  fetch: {
    integrationStates() {
      return this.app.stores.IntegrationsStore.fetchIntegrationStates()
    },
    hubspotTimelineState() {
      return this.app.stores.IntegrationsStore.fetchHubspotTimelineState()
    },
    hubspotCookieState() {
      return this.app.stores.IntegrationsStore.fetchHubspotCookieState()
    },
    orgProps() {
      return this.app.stores.OrgPropertiesStore.fetchPropertiesForCurrentOrg()
    },
    org() {
      return this.app.stores.OrgStore.getOrFetchCurrentOrg()
    },
  }
})

export default HubSpotContainer



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/HubSpot.js